import type { ReactNode } from "react";

/** Flexible selectors use available title-bar space; actions retain their own width. */
export function AppShellContextControls({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return <div className="mq-app-shell-context-controls"><div className="mq-app-shell-context-fields">{children}</div>{actions}</div>;
}
